import styled from '@emotion/styled';

import { font, fontFamily, fontSize, fontWeight } from 'ms-styles/base';
import Button from 'ms-ui-primitives/Button';
import { Anchor } from 'ms-ui-primitives/Link';

import image from './404.svg';

const Error = styled.h1({
  ...font.gilroyExtraLargeHeading,
});

const Message = styled.div({
  fontFamily: fontFamily.body,
  fontSize: fontSize.large,
  fontWeight: fontWeight.semibold,
  lineHeight: '26px',
  marginTop: 24,
  marginBottom: 24,
});

const Submessage = styled.p({
  fontFamily: fontFamily.body,
  maxWidth: 635,
  textAlign: 'center',
  lineHeight: 1.25,
  marginBottom: 24,
});

export default function FreeTextbooksNotFoundPage({
  escapePath,
}: {
  escapePath: string;
}) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <img alt="not found" src={image} width={635} />
      <Error>Error</Error>
      <Message>Something went wrong</Message>
      <Submessage>
        Please try refreshing the page, or you can return to the page you came
        from. If the problem persists, please email the Mathspace team.
      </Submessage>
      <Anchor href={escapePath}>
        <Button isRound color="cloudBurst" type="primary">
          Go to Mathspace.co
        </Button>
      </Anchor>
    </div>
  );
}
